/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';

import { AlertService } from '../../services/alert.service';
import { PaymentsCardService } from '../../services/payments-card/payments-card.service';
import { DEFAULT_MODAL_OPTIONS } from '../../variables/variables';

@Component({
  selector: 'card-on-file-dropdown',
  templateUrl: './card-on-file-dropdown.component.html',
  styleUrls: ['./card-on-file-dropdown.component.scss'],
})
export class CardOnFileDropdownComponent implements OnChanges {
  @Input() cards: any[] = [];
  @Input() resetDropdown = false;
  @Input() showDeleteIcon = true;
  @Output() cardSelected = new EventEmitter<any>();

  dropdownOpen = false;
  selectedCard: any;
  cardToDelete: any;
  private deleteDialogBoxModalRef: NgbModalRef;

  @ViewChild('deleteDialogBox') deleteDialogBox: TemplateRef<any>;

  constructor(
    private paymentsCardService: PaymentsCardService,
    private modalService: NgbModal,
    private alertService: AlertService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.resetDropdown.currentValue) {
      this.reset();
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectCard(card: any, event: Event) {
    if ((event.target as HTMLElement).classList.contains('delete-icon')) {
      return;
    }
    this.selectedCard = card;
    this.cardSelected.emit(card);
    this.dropdownOpen = false;
  }

  confirmRemoveCard(card: any, event: Event) {
    event.stopPropagation();
    this.cardToDelete = card;
    this.deleteDialogBoxModalRef = this.modalService.open(
      this.deleteDialogBox,
      { ...DEFAULT_MODAL_OPTIONS, size: 'sm' },
    );
  }

  async removeCard() {
    try {
      const response = await firstValueFrom(
        this.paymentsCardService.deletePaymentCardForPatient(
          (this.cardToDelete.cardId as number).toString(),
        ),
      );

      if (response?.cardId === this.cardToDelete.cardId) {
        this.deleteDialogBoxModalRef.close();
        this.alertService.success(
          'Success',
          `Your card ${this.cardToDelete.maskedCardNumber} has been deleted successfully.`,
        );
        this.cards = this.cards.filter((card) => {
          return card !== this.cardToDelete;
        });
      } else {
        this.deleteDialogBoxModalRef.close();
        this.alertService.error(
          'Failed',
          `Unable to delete your card ${this.cardToDelete.maskedCardNumber}`,
        );
      }
    } catch (error) {
      console.log(error);
      this.deleteDialogBoxModalRef.close();
      this.alertService.error(
        'Failed',
        'Delete card operation failed due to an unexpected error.',
      );
    }
  }

  reset() {
    this.selectedCard = null;
    this.dropdownOpen = false;
  }
}
